import React from "react";
import { cancelIcon, chevronBottom } from "../../../../Base/SVG";

export default function Payment() {
  return (
    <div className="guides">
      <h5>
        <span className="orange"></span> Invoice payment
      </h5>
      <div className="guides__text">
        <p>
          On the page that opens, you will see the name and description of the
          user who created the invoice (if any), as well as information about
          the invoice: amount, commission, total amount to be debited, including
          commission.
        </p>
        <p>
          Select the network and token
          <div className="customSelect">
            <div className="customSelect__selected">
              <img
                src={process.env.PUBLIC_URL + "/images/networks/eth.svg"}
                alt="eth"
              />
              Ethereum
              {chevronBottom}
            </div>
          </div>
          <div className="customSelect">
            <div className="customSelect__selected">
              <img
                src={process.env.PUBLIC_URL + "/images/networks/binance.svg"}
                alt="binance"
              />
              BUSD
              {chevronBottom}
            </div>
          </div>
        </p>
        <p>
          you want to pay with from the drop-down list (only those tokens and
          networks that the invoice creator has chosen are available).
        </p>
        <p>
          Click
          <a href="#" className="button primary">
            Connect Wallet
          </a>
          and confirm the operations (change network if it necessary) in
          MetaMask.
        </p>
        <p>
          Click Send Payment and sign the transactions in MetaMask (signature
          request, transaction confirmation).
        </p>
        <p>
          After successful payment of the invoice, the form will be blocked and
          a notification of successful payment will appear.
        </p>
      </div>
    </div>
  );
}
